<template>
  <div class="container">
    <!-- 头部 -->
    <van-nav-bar fixed title="积分说明" left-arrow @click-left="onClickLeft" id="vnb" />

    <!-- tab栏 -->
    <div class="tab">
      <van-tabs class="tab-list" v-model="active">
        <van-tab title="积分获取" class="one fy">
          <div class="text-title fy">投资指定资产</div>
          <div
            class="text fy"
          >当您投资带有“返积分”标签的资产，即可获得相应积分，奖励积分=投资金额*投资期限/365*{{ scoreRate }}%（小数按四舍五入处理，精确到个位）。</div>
          <div
            class="text fy"
            style="margin-top: 10px;"
          >举例：投资“返积分”365天资产1万元，即可获得{{ num }}积分，投资“返积分”187天资产1万元，即可获得{{point}}积分。</div>
          <div class="text-ex fy">说明：奖励积分不和其他优惠活动同享，奖励积分在成功投资资产时即发放。</div>
        </van-tab>

        <van-tab title="积分规则" class="one fy">
          <div class="text-title fy">积分使用</div>
          <div class="text fy">积分可在积分兑换商城中根据相应的兑换规则，兑换礼品。</div>
          <div class="text-title fy" style="margin-top: 20px;">积分说明</div>
          <div class="text fy">1、每一笔积分的有效期为2年，未进行使用的积分将于2年后过期。</div>
          <div class="text fy">2、如在资产起息前取消投资，已获得积分将被平台收回。</div>
          <div class="text fy">3、奖励积分和红包在积分兑换商城不能同时使用，也不可在认购资产时作为现金使用。</div>
          <div class="text fy">4、平台有权自主变更积分获取方式、积分可使用渠道和可兑换礼品范围，对风险客户有权冻结相关积分使用或取消已赠予的积分。</div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import * as GoodsApi from '@/api/goods';
import { Toast, Tab, Tabs } from 'vant';
export default {
  components: {

    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  data () {
    return {
      active: 2,
      scoreRate: '',
      point: '',
      num: ''
    };
  },
  beforeMount () {
    GoodsApi.getScoreRate()
      .then(data => {
        this.scoreRate = data.scoreRate;
        // 不保留两位小数
        let point = (((10000 * 187) / 365) * this.scoreRate) / 100;
        point = point.toFixed();
        this.point = point

        let num = (((10000 * 365) / 365) * this.scoreRate) / 100;
        num = num.toFixed();
        this.num = num
      })
      .catch(e => {
        Toast(e.msg || e.message);
      });
  },
  methods: {
    onClickLeft () {
      this.goableBack();
    }
  }
};
</script>

<style lang="less" scoped="">
.container {
  height: 100%;
  background-color: #f3f4f6;
  overflow: hidden;
}
// navBar
/deep/ .van-nav-bar {
  background-color: #ffffff !important;
  background-image: none;
}

#vnb /deep/ .van-nav-bar__title {
  color: #000000 !important;
  font-size: 16px;
  font-family: 'PingFangSC Medium';
}

#vnb /deep/ .van-nav-bar__left .van-icon {
  color: #000000 !important;
  font-size: 16px;
}

// tab
/deep/ .van-tabs__wrap {
  margin: 0 60px;
}
/deep/ .van-tabs__nav {
  margin: 0;
}
/deep/ .van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  height: 0.05rem;
  background-color: #000000;
  border-radius: 0.08rem;
}
/deep/ .van-tab__text {
  font-size: 15px;
  background: rgba(255, 255, 255, 0.6);
}

.tab {
  min-height: 413px;
  margin: 60px 20px 0;
  background-color: #ffffff;
  // border: 1px solid #323233;
  border-radius: 6px;
  overflow: hidden;

  .tab-list {
    .van-tabs--line,
    .van-tabs__wrap {
      border: 1px solid #000000;
      height: 50px;
    }

    .one {
      padding: 20px;

      .text-title {
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 5px;
      }

      .text {
        font-size: 14px;
        margin-bottom: 10px;
      }

      .text-ex {
        margin-top: 10px;
        font-size: 14px;
      }
    }
  }
}
//
</style>
